import { render } from "./bedroomSpace.vue?vue&type=template&id=7f72d5ed&scoped=true"
import script from "./bedroomSpace.vue?vue&type=script&lang=js"
export * from "./bedroomSpace.vue?vue&type=script&lang=js"

import "./bedroomSpace.vue?vue&type=style&index=0&id=7f72d5ed&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f72d5ed"]])

export default __exports__